import React, { useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import Table from 'components/Table/Table';
import { wsUpdate } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';

function ErrorOrdersModal(props) {
  const { model, setOpen } = props;
  const { showNotify, listProgramming } = props;
  const [processing, setProcessing] = useState(false);

  async function restore() {
    setProcessing(true);
    let res = await wsUpdate(`prog/sheet-distribution/${model.id}/restore-gcount`);
    setProcessing(false);
    if (res.success) {
      showNotify(res.message);
      listProgramming();
      setOpen({ open: false });
    }
  }

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      hideSave
      maxWidth="sm"
      title={`Pedidos de hoja ${model.id || 0} con error`}
    >
      {!!model.error_orders && (
        <Table
          tableHead={['#', 'Codigo', 'Cliente', 'Total', 'Error']}
          tableData={model.error_orders.map((order, index) => {
            return [
              index + 1,
              order.CardCode,
              order.CardName,
              order.total_migrate,
              order.ObservacionError,
            ];
          })}
        />
      )}
      <RegularButton color="warning" onClick={restore} disabled={processing}>
        Volver a procesar
      </RegularButton>
    </ModalBase>
  );
}

export default ErrorOrdersModal;
